export default __webpack_public_path__ + "static/media/addDone.e6ffd99b.svg";